module.exports = __webpack_public_path__ + "static/media/axiseng-m-e-ltd.95cfbd84.png";